import { Injectable } from '@angular/core';
import { BffCommunicationService } from '../../core/services/_index';
import { Observable } from 'rxjs';
import { InfoDemandeSupportNumerique } from '../modeles/info';
import { AppConfigService } from '../../app-config.service';

@Injectable({
  providedIn: 'root'
})
export class SupportApiService {
  constructor(
    private readonly _bffApiService: BffCommunicationService,
    private readonly _appConfigService: AppConfigService
  ) {}

  private getApiUrlPrefix() {
    return `/api/v2/personnes`;
  }

  private getApiUrlPrefixAssurance() {
    return `/api/v1/projets/${this._appConfigService.idProjet}`;
  }

  updateInfoDemandeSupportNumerique(infoDemandeSupportNumerique: InfoDemandeSupportNumerique): Observable<any> {
    return this._bffApiService.postJSONBFF(
      this.getApiUrlPrefix() + '/demandesupport',
      JSON.stringify(infoDemandeSupportNumerique)
    );
  }

  updateClickTelAssuranceHab(): Observable<any> {
    return this._bffApiService.putJSONBFF(this.getApiUrlPrefixAssurance() + '/assurancehabitation');
  }

  updateClickTelAssurancePret(): Observable<any> {
    return this._bffApiService.putJSONBFF(this.getApiUrlPrefixAssurance() + '/assurancepret');
  }
}
